export const CASUAL_GAME_SLUGS = ["rune-forge", "hidden-relics", "wyrm-pop", "ricochet-ruins"] as const;
export type CasualGameSlug = typeof CASUAL_GAME_SLUGS[number];
export type CasualThemeId = "default" | "moonstone" | "ember";

export const CASUAL_GAME_DEFINITIONS = [
  { slug: "rune-forge", title: "Rune Forge", category: "puzzle-games", summary: "Carve a little order from the chaos. Place runes, clear lines, and keep the forge alive." },
  { slug: "hidden-relics", title: "Hidden Relics", category: "puzzle-games", summary: "Read the clues, uncover the picture, and fill a cabinet of forgotten treasures." },
  { slug: "wyrm-pop", title: "Wyrm Pop", category: "arcade-games", summary: "A tiny dragon. A perfect bank shot. A sky full of enchanted orbs." },
  { slug: "ricochet-ruins", title: "Ricochet Ruins", category: "arcade-games", summary: "Find the angle and bring the haunted towers down, one spectral volley at a time." },
] as const;

export const CASUAL_THEMES = [
  { id: "default", name: "Original", description: "The complete original game appearance, included free.", price: 0 },
  { id: "moonstone", name: "Moonstone", description: "Cool moonlit colors and luminous silver accents.", price: 250 },
  { id: "ember", name: "Ember", description: "A warm vermilion and gold alternate appearance.", price: 250 },
] as const;

export interface CasualShopItem {
  id: CasualThemeId;
  name: string;
  description: string;
  included: boolean;
  owned: boolean;
  available: boolean;
  price: number;
  pricingVersion: number;
}
export interface CasualShopState {
  game: CasualGameSlug;
  authenticated: boolean;
  balance: number | null;
  selectedTheme: CasualThemeId;
  items: CasualShopItem[];
}
export interface CasualPurchaseResult {
  duplicate: boolean;
  themeId: CasualThemeId;
  balance: number;
  shop: CasualShopState;
}
export function isCasualGame(value: unknown): value is CasualGameSlug {
  return typeof value === "string" && CASUAL_GAME_SLUGS.some((slug) => slug === value);
}
export function isCasualTheme(value: unknown): value is CasualThemeId {
  return value === "default" || value === "moonstone" || value === "ember";
}
